<div *ngIf="isAddToEmployeeModalOpen" class="overlay">
  <div #addEmployeeJobModal class="job-card-modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="heading-container">
      <p class="heading-title">Add Employee To {{ selectedRow.cardType }} ({{ selectedName }})</p>
      <a href="#" (click)="handleClose(); $event.preventDefault()"
        ><img style="height: 12px; width: 12px" src="/assets/images/icon/close_white.svg"
      /></a>
    </div>
    <div class="h-100 modal-container">
      <div class="row">
        <div class="col-12">
          <div class="tab-content body-content-scroll scrollbar">
            <div class="tab-pane show active" id="information-info" role="tabpanel">
              <div class="card mt-1 border-white">
                <div class="card-body mt-3 mb-0">
                  <app-add-employee-list [cardData]="selectedRow"></app-add-employee-list>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
